import * as types from "../action/ActionType";

interface RequiredInvoiceLineItemAction {
  type: string;
  payload: unknown[];
}

export default function Requiredinvoicelineitem(
  state: unknown[] = [],
  action: RequiredInvoiceLineItemAction
): unknown[] {
  const { type, payload } = action;
  switch (type) {
    case types.REQUIRED_INVOICE_LINE_ITEM:
      return payload;
    default:
      return state;
  }
}
